export function getNumaSupportEmail(inboxType?: string): string {
  return inboxType?.startsWith('auto')
    ? 'autosupportteam@numa.com'
    : 'support@numa.com';
}
